export const moods = [
  {
    id: "think",
    icon: "ri-stethoscope-line",
    title: "想安静地想点事",
    desc: "节奏缓、对白多，适合一个人看完再慢慢回味。",
    picks: ["爱", "海边的曼彻斯特", "迷失东京"],
  },
  {
    id: "family",
    icon: "ri-home-heart-line",
    title: "想聊家人与亲情",
    desc: "围绕亲子、照护与家庭责任展开，看完很容易有话想说。",
    picks: ["克莱默夫妇", "房间", "八月：奥色治郡"],
  },
  {
    id: "relationship",
    icon: "ri-heart-3-line",
    title: "想聊一段关系",
    desc: "关于相遇、相处与分开，重点在两个人的沟通方式。",
    picks: ["婚姻故事", "蓝色情人节", "爱在黎明破晓前"],
  },
  {
    id: "society",
    icon: "ri-global-line",
    title: "想看点社会议题",
    desc: "从个人处境出发，牵出偏见、责任与公共话题。",
    picks: ["撞车", "聚焦", "三块广告牌"],
  },
  {
    id: "grow",
    icon: "ri-seedling-line",
    title: "想看看成长",
    desc: "关于身份、选择与时间如何塑造一个人。",
    picks: ["月光男孩", "少年时代", "心灵捕手"],
  },
  {
    id: "short",
    icon: "ri-time-line",
    title: "只有一段时间",
    desc: "结构清晰、容易进入状态，不想被复杂线索绊住。",
    picks: ["心灵捕手", "她", "断背山"],
  },
];